<template>
    <module-card :nextDisabled="nextDisabled" :nextFunction="checkAnswer">
        <p class="text-h6 text-center">{{ question }}</p>

        <v-container grid-list-xs>
            <v-row wrap justify-center no-gutters>
                <v-col cols="6">
                    <div class="img-container">
                        <v-img v-if="!trueSelected" class="mx-auto" :max-width="200" :src="require('@/assets/hiv/buttonTrue.png')" alt="True" @click="selectTrue"></v-img>
                        <v-img v-else class="mx-auto" :max-width="200" :src="require('@/assets/hiv/buttonTrue_pressed.png')" alt="True"></v-img>
                        <div class="img-text">
                            <h1>True</h1>
                        </div>
                    </div>
                </v-col>
                <v-col cols="6">
                    <div class="img-container">
                        <v-img v-if="!falseSelected" class="mx-auto" :max-width="200" :src="require('@/assets/hiv/buttonFalse.png')" alt="False" @click="selectFalse"></v-img>
                        <v-img v-else class="mx-auto" :max-width="200" :src="require('@/assets/hiv/buttonFalse_pressed.png')" alt="False"></v-img>
                        <div class="img-text">
                            <h1>False</h1>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    import { shuffle } from 'lodash';

    export default {
        data() {
            return {
                trueSelected: false,
                falseSelected: false,
                incorrectMessages: ['Good try, give it another shot', 'Not Quite! Try again', 'Close!']
            };
        },
        props: {
            question: {
                type: String,
                required: true
            },
            answer: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            selectTrue() {
                this.trueSelected = true;
                this.falseSelected = false;
            },
            selectFalse() {
                this.trueSelected = false;
                this.falseSelected = true;
            },
            nextDisabled() {
                return !(this.trueSelected || this.falseSelected);
            },
            checkAnswer() {
                if ((this.answer && this.trueSelected) || (!this.answer && this.falseSelected)) {
                    return true;
                } else {
                    this.$refs.modalFeedback.show(false, shuffle(this.incorrectMessages)[0], null);
                    return false;
                }
            }
        }
    };
</script>

<style scoped>
    .img-container {
        position: relative;
    }

    /* center text on image */
    .img-text {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        pointer-events: none;
    }
</style>
